// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"532":"837d469b85c1b4a22bf3","691":"4784ad0ccc3da88f7199"}[chunkId] + ".js";
};